
define('template!sdcName',[''],function(template){return '<span class="display-label" ng-transclude></span>\r\n';});

